// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"1538309b","618":"7991a79b"}[chunkId] + ".chunk.js";
};